/* SIFI BEAUVOIS — Footer — inscription newsletter via l'API client Klaviyo
   (remplace le formulaire natif Shopify ; clés publiques : Site ID + List ID). */
      (function () {
        var KLAVIYO_PUBLIC_KEY = 'V7eJ6N'; /* Klaviyo → Settings → API keys → Public API key (Site ID), 6 caractères */
        var KLAVIYO_LIST_ID = 'TFmn3n';        /* Klaviyo → Lists & segments → Newsletter → Settings → List ID */

        /* Langue d'inscription, code court ('fr', 'en'). Une inscription n'est
           pas un evenement : la langue va donc en PROPRIETE DE PROFIL, lisible
           dans la fiche du profil et utilisable en condition de flow. On coupe
           au tiret ('en-CH' -> 'en') pour que la comparaison reste exacte. */
        var LANGUE = String((document.documentElement && document.documentElement.lang) || 'fr')
          .toLowerCase().split('-')[0] || 'fr';

        document.querySelectorAll('.sb-footer__newsletter-klaviyo').forEach(function (form) {
          if (form.dataset.klaviyoInit === '1') return;
          form.dataset.klaviyoInit = '1';

          /* Message d'erreur pose par le Liquid (cle footer.newsletter_error), repli FR. */
          var errMsg = form.getAttribute('data-txt-error') || 'Une erreur est survenue, merci de réessayer.';

          var input = form.querySelector('.sb-footer__newsletter-input');
          var field = form.querySelector('.sb-footer__newsletter-field');
          var button = form.querySelector('.sb-footer__newsletter-submit');
          var success = form.querySelector('.sb-footer__newsletter-success');
          var error = form.querySelector('.sb-footer__newsletter-error');

          form.addEventListener('submit', function (e) {
            e.preventDefault();
            if (success) success.hidden = true;
            if (error) error.hidden = true;

            var email = (input.value || '').trim();
            if (!email) return;
            button.disabled = true;

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_PUBLIC_KEY, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'revision': '2026-04-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: 'Formulaire newsletter (footer) - ' + LANGUE,
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email,
                          properties: { langue: LANGUE },
                          subscriptions: {
                            email: { marketing: { consent: 'SUBSCRIBED' } }
                          }
                        }
                      }
                    }
                  },
                  relationships: {
                    list: { data: { type: 'list', id: KLAVIYO_LIST_ID } }
                  }
                }
              })
            }).then(function (res) {
              button.disabled = false;
              if (res.status === 202) {
                form.reset();
                if (field) field.style.display = 'none';
                button.style.display = 'none';
                if (success) success.hidden = false;
              } else if (error) {
                error.textContent = errMsg;
                error.hidden = false;
              }
            }).catch(function () {
              button.disabled = false;
              if (error) {
                error.textContent = errMsg;
                error.hidden = false;
              }
            });
          });
        });
      })();